
import React, { useState, useEffect } from "react";
import "./PortfolioRelated.scss";

import { slidesData2 } from "../../data/data";

const PortfolioRelated = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent(current === slidesData2.length - 1 ? 0 : current + 1);
    }, 1800);

    return () => clearInterval(interval);
  }, [current]);

  return (
    <section className="section portfolioRelated">
      <article className=" portfolioRelated__container container">
        <div className="portfolioRelated__container--header">
          <h2 className="header__title">Related</h2>
          <h3 className="homeWork__subtitle">Case Studies</h3>
        </div>
        <div className="portfolioRelated__container--content">
          <div className="portfolioRelated__container--content-left">
            <div
              className="content-left--img"
              style={{
                backgroundImage: `url(${slidesData2[current]})`,
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            ></div>

            <div className="content-left--text">
              <h3>Transcend Build & Design - Housing and Real Estate</h3>
              <p>Website Design - Branding</p>
            </div>
          </div>
        </div>
      </article>
    </section>
  );
};

export default PortfolioRelated;
